export const UPDATE_RAW_SCROLL = 'update window raw scroll position'
export const updateRawScroll = (rawScrollX, rawScrollY) => ({
  type: UPDATE_RAW_SCROLL,
  rawScrollX,
  rawScrollY,
})

export const UPDATE_SCROLL = 'update window scroll position and raw scroll position'
export const updateScroll = (scrollX, scrollY) => ({
  type: UPDATE_SCROLL,
  scrollX,
  scrollY,
})

export const UPDATE_VIEWPORT = 'update window viewport size'
export const updateViewport = (viewportWidth, viewportHeight) => ({
  type: UPDATE_VIEWPORT,
  viewportWidth,
  viewportHeight,
})
